import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const SensorAccessControl = () => {
  const navigate = useNavigate();
  const usersSummary = useSelector((e) => e.usersSummary.usersSummary);

  useEffect(() => {
    const isEmpty = !usersSummary || Object.keys(usersSummary).length === 0;

    if (isEmpty) return;

    if (!usersSummary.ai_solutions_enabled) {
      navigate("/404/invalid_user_type");
    }
  }, [usersSummary, navigate]);

  return <Outlet />;
};

export default SensorAccessControl;
